import { render, staticRenderFns } from "./DiagAnswerInput.vue?vue&type=template&id=5ea77984&scoped=true&"
import script from "./DiagAnswerInput.vue?vue&type=script&lang=js&"
export * from "./DiagAnswerInput.vue?vue&type=script&lang=js&"
import style0 from "./DiagAnswerInput.vue?vue&type=style&index=0&id=5ea77984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea77984",
  null
  
)

export default component.exports